export enum MatchCardConfig {
  FULL = "full",
  CLUB = "club",
  SHORT = "short"
}
